<div class="signup-info">
  <div class="flex-container pl-0 md:pl-6 pt-5 w-full text-left">
    <div class="flex-25">
      <app-logo width="120" type="w" />
    </div>
    <div class="flex-40"></div>
    <div class="flex-25">
      <div class="w-full mb-3">
        <span class="signup-header" [innerHTML]="'login.page.usermsg' | translate"></span>
      </div>
    </div>
    <div class="flex-10 remove-in-mobile">
      <div class="links-text">
        <a target="_blank" href="/static-pages/privacy-policy"> {{ 'Footer.PrivacyPolicy' | translate }}</a
        >&nbsp; |&nbsp;
        <a target="_blank" href="/static-pages/legal-notice"> {{ 'Footer.LegalNotice' | translate }}</a>
        &nbsp;|&nbsp;
        <a target="_blank" href="/static-pages/cookie-policy"> {{ 'Footer.CookiePolicy' | translate }}</a>
      </div>
    </div>
  </div>
</div>
